import "./planet-order-badge.css";

export default function PlanetBadge({pageNumber}) {
  return (
      <div className="planet-order-element">{pageNumber}</div>
  );
}
